import Api from "@/services/Api";

export default {
  async uploadVideo(formData, progress, timeout) {
    const response = await Api(timeout).post("content/video/social", formData, {
      onUploadProgress: (uploadEvent) => {
        progress(uploadEvent);
      },
    });
    return response.data;
  },
  async uploadImage(formData, progress, timeout) {
    const response = await Api(timeout).post("content/image/social", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (uploadEvent) => {
        progress(uploadEvent);
      },
    });
    return response.data;
  },
  async uploadFile(formData, progress, timeout) {
    const response = await Api(timeout).post("content/file/social", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (uploadEvent) => {
        progress(uploadEvent);
      },
    });
    return response.data;
  },
};
